/* eslint-disable eag/match-named-export -- Pre-existing grab-bag file with several exports */
import styled from 'styled-components';

import {Button, TypographyCard} from '@dms/teas';

// eslint-disable-next-line eag/no-css-property -- Muted pre-existing violation
export const WrapperCard = styled(TypographyCard)`
  margin: ${({theme}) => theme.getSize(4)} 0;
  position: relative;
`;

export const ButtonWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
`;

// eslint-disable-next-line eag/no-css-property -- Muted pre-existing violation
export const ButtonSave = styled(Button)`
  margin: ${({theme}) => theme.getSize(2)};
`;
